import type { RoleType } from "@/api/login/types/login"
import {
  getRoleProfileLabel,
  resolveRoleProfile as resolveSharedRoleProfile,
  type RoleProfileCode,
  type RoleProfileResult,
} from "@repo/teashop-utils"

export type { RoleProfileCode }
export { getRoleProfileLabel }

const hasPermission = (permissions: string[], key: string) => permissions.includes(key)

const hasAnyPermission = (permissions: string[], keys: string[]) => {
  return keys.some((key) => hasPermission(permissions, key))
}

export type RoleProfile = RoleProfileResult

export const resolveRoleProfile = (permissions: string[], roles: RoleType[] = []): RoleProfile => {
  return resolveSharedRoleProfile({ roles, permissionList: permissions })
}

export const resolveRoleDefaultHomePath = (profile: RoleProfile, permissions: string[]) => {
  const candidatesByProfile: Record<RoleProfileCode, Array<{ path: string, permissions: string[] }>> = {
    owner: [
      { path: "/dashboard/overview/index", permissions: ["dashboard_info_all"] },
      { path: "/dashboard/business-report/collection-statistics/index", permissions: ["dashboard_business_all"] },
      { path: "/business/index", permissions: ["business"] },
      { path: "/procurement/home", permissions: ["procurement_all", "procurement_info", "procurement"] },
    ],
    manager: [
      { path: "/dashboard/overview/index", permissions: ["dashboard_info_all"] },
      { path: "/business/index", permissions: ["business"] },
      { path: "/dashboard/business-report/collection-statistics/index", permissions: ["dashboard_business_all"] },
      { path: "/procurement/home", permissions: ["procurement_all", "procurement_info", "procurement"] },
      { path: "/stock/stock-stat/index", permissions: ["stock_info"] },
      { path: "/stock/stock-manage/stock-stat/index", permissions: ["stock_info"] },
    ],
    shareholder: [
      { path: "/dashboard/overview/index", permissions: ["dashboard_info_all"] },
      { path: "/dashboard/business-report/collection-statistics/index", permissions: ["dashboard_business_all"] },
      { path: "/dashboard/business-report/billing-details/index", permissions: ["dashboard_business_order"] },
    ],
    finance: [
      { path: "/dashboard/overview/index", permissions: ["dashboard_info_all"] },
      { path: "/dashboard/business-report/collection-statistics/index", permissions: ["dashboard_business_all"] },
      { path: "/dashboard/business-report/billing-details/index", permissions: ["dashboard_business_order"] },
      { path: "/dashboard/operation-record/index", permissions: ["dashboard_operation_record"] },
    ],
    cashier: [
      { path: "/business/index", permissions: ["business"] },
      { path: "/dashboard/business-report/billing-details/index", permissions: ["dashboard_business_order"] },
    ],
    waiter: [
      { path: "/business/index", permissions: ["business"] },
      { path: "/dashboard/business-report/billing-details/index", permissions: ["dashboard_business_order"] },
    ],
  }

  const candidates = candidatesByProfile[profile.code]
  return candidates.find((candidate) => hasAnyPermission(permissions, candidate.permissions))?.path
}
